import { render, staticRenderFns } from "./CurriculumList.vue?vue&type=template&id=1927fae6&"
import script from "./CurriculumList.vue?vue&type=script&lang=ts&"
export * from "./CurriculumList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports